/*
 * @Author: liyxt
 * @Date: 2020-04-07 11:41:26
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-01 14:32:24
 * @Description: file content
 */ 

import { getTopWindow } from './window.js';

/**
 * 获取业务信息：集团、用户、业务日期等
 * @memberof SystemContext
 * @returns {BusinessInfo} BusinessInfo
 */
export function getBusinessInfo(config) {
    if (getTopWindow() && typeof getTopWindow().GETBUSINESSINFO === 'function') {
        return getTopWindow().GETBUSINESSINFO(config);
    }
}
/**
 * BusinessInfo参数说明
 * @memberof SystemContext
 * @typedef BusinessInfo
 * @property {string} businessDate 系统业务日期	
 * @property {string} groupId	 集团id	
 * @property {string} groupName 集团名称	
 * @property {string} projectCode 项目编码	
 * @property {string} userId 用户id	
 * @property {string} userCode 用户编码	
 * @property {string} userName	用户名称	
*/